import { h } from 'preact';
import { BaseAnnotation } from './base_annotation';
import { Canvas } from '../components/canvas';
import { focusable } from 'utilities/accessibility';

export class DrawingAnnotation extends BaseAnnotation {
    render() {
        const width = this.options.dimensions.video ? this.options.dimensions.video.width : 1280,
            height = this.options.dimensions.video ? this.options.dimensions.video.height : 720,
            scale = {
                x: width / this.options.drawing.width,
                y: height / this.options.drawing.height
            },
            paths = this.options.drawing.paths.map(this.scalePath.bind(this, scale)),
            canvasAttrs = {
                'aria-label': this.options.altText,
                role: 'img',
                ...focusable
            };

        return (
            <div className={ this.classes } style={ this.containerStyle } { ...this.dataAttrs } { ...this.applyActions(this.actions) }>
                <Canvas width={ width } height={ height } paths={ paths } attrs={ canvasAttrs }/>
            </div>
        )
    }

    scalePath(scale, path) {
        return {
            ...path,
            points: path.points.map(point => ({
                ...point,
                x: point.x * scale.x,
                y: point.y * scale.y,
                lineWidth: this.scaleLineWidth(path, scale)
            }))
        };
    }

    scaleLineWidth(path, scale) {
        return Math.max(1, (path.lineWidth || this.options.drawing.stroke || 5) * scale.x)
    }

    get legacyClasses() {
        return 'popcorn-drawing active';
    }

    get containerStyle() {
        return {
            position: 'absolute',
            width: '100%',
            height: '100%'
        };
    }

    get options() {
        return {
            ...super.options,
            dimensions: this.props.dimensions || {},
            drawing: super.options.drawing || {
                paths: []
            }
        }
    }

    static get schemaType() {
        return 'drawing';
    }
}